export const STAFF_KINDS = [
    { value: 'doctor', label: 'Doctor', isDoctor: true },
    { value: 'nurse', label: 'Nurse', isDoctor: false },
    { value: 'midwife', label: 'Midwife', isDoctor: false },
    { value: 'pharmacist', label: 'Pharmacist', isDoctor: false },
    { value: 'lab_technologist', label: 'Lab technologist', isDoctor: false },
    { value: 'lab_assistant', label: 'Lab assistant', isDoctor: false },
    { value: 'phlebotomist', label: 'Phlebotomist', isDoctor: false },
    { value: 'radiographer', label: 'Radiographer', isDoctor: false },
    { value: 'physiotherapist', label: 'Physiotherapist', isDoctor: false },
    { value: 'dietitian', label: 'Dietitian', isDoctor: false },
    { value: 'receptionist', label: 'Receptionist', isDoctor: false },
    { value: 'cashier', label: 'Cashier', isDoctor: false },
    { value: 'accountant', label: 'Accountant', isDoctor: false },
    { value: 'hr_officer', label: 'HR officer', isDoctor: false },
    { value: 'administrator', label: 'Administrator', isDoctor: false },
    { value: 'it_support', label: 'IT support', isDoctor: false },
    { value: 'ward_attendant', label: 'Ward attendant', isDoctor: false },
    { value: 'ambulance_driver', label: 'Ambulance driver', isDoctor: false },
    { value: 'housekeeping', label: 'Housekeeping', isDoctor: false },
    { value: 'security', label: 'Security', isDoctor: false },
];
export const OTHER_STAFF_KIND = 'other';
export function staffKindForDesignation(designation, isDoctor) {
    if (isDoctor)
        return 'doctor';
    const text = (designation ?? '').trim().toLowerCase();
    if (!text)
        return '';
    return STAFF_KINDS.find((kind) => kind.label.toLowerCase() === text)?.value ?? OTHER_STAFF_KIND;
}
//# sourceMappingURL=staff-kinds.js.map